module.exports = __webpack_public_path__ + "static/emulation-emulation-a72a65c50b6c10f5e9cfc78d69c5547a.png";